import React from 'react';
import type { SVGProps } from 'react';

interface TopicIconSvgProps extends SVGProps<SVGSVGElement> {}

export const WorkIcon: React.FC<TopicIconSvgProps> = (props) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M13.7002 1.9248C19.2556 1.9248 23.7742 6.44438 23.7744 11.999C23.7744 17.5538 19.2557 22.0752 13.7002 22.0752C10.5768 22.0751 7.61314 20.6093 5.71191 18.1396L5.53125 17.8975C5.36133 17.6618 5.41372 17.3324 5.64941 17.1621L5.74219 17.1084C5.96587 17.0074 6.23685 17.0741 6.38574 17.2803C8.07916 19.6224 10.8131 21.0214 13.7002 21.0215C18.6743 21.0215 22.7207 16.9745 22.7207 12.001C22.7205 7.02775 18.6742 2.97949 13.7002 2.97949C10.8569 2.97958 8.16897 4.3311 6.46875 6.60547C6.45128 6.65584 6.42745 6.70308 6.39648 6.74512C6.35604 6.8 6.30447 6.84528 6.24609 6.88086L6.24707 6.88184C6.09825 7.00299 5.89413 7.03278 5.71582 6.95996H1.43945C1.14808 6.95996 0.912109 6.72393 0.912109 6.43262C0.912318 6.14139 1.14822 5.90625 1.43945 5.90625H5.67773C7.57927 3.40755 10.5536 1.92489 13.7002 1.9248Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.15"
    />
    <path
      d="M13.7002 15.9644C13.9915 15.9644 14.2275 16.2003 14.2275 16.4917V17.4976C14.2274 17.7887 13.9914 18.0239 13.7002 18.0239C13.409 18.0239 13.173 17.7887 13.1729 17.4976V16.4917C13.1729 16.2003 13.4089 15.9644 13.7002 15.9644Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.15"
    />
    <path
      d="M19.1963 11.4729C19.4877 11.4729 19.7236 11.7088 19.7236 12.0002C19.7236 12.2915 19.4877 12.5276 19.1963 12.5276H18.1904C17.8991 12.5276 17.6631 12.2915 17.6631 12.0002C17.6631 11.7088 17.8991 11.4729 18.1904 11.4729H19.1963Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.15"
    />
    <path
      d="M9.20996 11.4729C9.50116 11.4731 9.73633 11.7089 9.73633 12.0002C9.73629 12.2914 9.50115 12.5274 9.20996 12.5276H8.2041C7.91274 12.5276 7.67679 12.2915 7.67676 12.0002C7.67676 11.7088 7.91273 11.4729 8.2041 11.4729H9.20996Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.15"
    />
    <path
      d="M13.7002 5.97632C13.9916 5.97635 14.2275 6.21241 14.2275 6.50366V7.50952C14.2274 7.80078 13.9914 8.03585 13.7002 8.03589C13.409 8.03589 13.173 7.80081 13.1729 7.50952V6.50366C13.1729 6.21238 13.4088 5.97632 13.7002 5.97632Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.15"
    />
    <path
      d="M17.415 8.01489C17.6085 7.83206 17.9102 7.84592 18.0869 8.04517C18.2624 8.24308 18.2485 8.55031 18.0566 8.73169L15.1201 11.5032C15.1093 11.5134 15.0975 11.5224 15.0859 11.5315C15.1654 11.7178 15.2119 11.9229 15.2119 12.1389C15.2117 12.9729 14.5539 13.6555 13.7402 13.6555C12.9266 13.6555 12.2687 12.9729 12.2686 12.1389C12.2686 11.3048 12.9265 10.6224 13.7402 10.6223C13.9993 10.6223 14.2415 10.6941 14.4531 10.8157C14.4616 10.8063 14.4692 10.7961 14.4785 10.7874L17.415 8.01489ZM13.7402 11.5959C13.4539 11.596 13.2168 11.8375 13.2168 12.1389C13.217 12.4402 13.454 12.6818 13.7402 12.6819C14.0265 12.6819 14.2635 12.4403 14.2637 12.1389C14.2637 11.8374 14.0266 11.5959 13.7402 11.5959Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.15"
    />
    <path
      d="M13.6992 3.9231C18.1529 3.9231 21.7764 7.54653 21.7764 12.0002C21.7762 16.4537 18.1526 20.0762 13.6992 20.0764C9.24564 20.0764 5.62227 16.4538 5.62207 12.0002C5.62207 10.6457 5.96416 9.30438 6.6123 8.12231C8.03261 5.53243 10.748 3.92319 13.6992 3.9231ZM13.6992 4.93384C11.1178 4.93384 8.7418 6.34135 7.49902 8.60767C6.93251 9.64089 6.63282 10.8136 6.63281 11.9993C6.63281 15.8953 9.80316 19.0647 13.6992 19.0647C17.5951 19.0645 20.7646 15.8952 20.7646 11.9993C20.7646 8.10339 17.5951 4.93402 13.6992 4.93384Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.15"
    />
    <path
      d="M4.5166 14.2666C4.80799 14.2666 5.04395 14.5027 5.04395 14.7939C5.04391 15.0854 4.80795 15.3213 4.5166 15.3213H0.947266C0.65593 15.3213 0.419958 15.0854 0.419922 14.7939C0.419922 14.5027 0.655892 14.2666 0.947266 14.2666H4.5166Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.15"
    />
    <path
      d="M4.15039 11.4797C4.44168 11.4798 4.67773 11.7158 4.67773 12.0071C4.6777 12.2985 4.44095 12.5343 4.15039 12.5344H0.751953C0.460621 12.5344 0.224645 12.2985 0.224609 12.0071C0.224609 11.7158 0.460583 11.4797 0.751953 11.4797H4.15039Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.15"
    />
    <path
      d="M4.56836 8.69312C4.8597 8.69312 5.0957 8.92901 5.0957 9.22046C5.09567 9.51181 4.859 9.7478 4.56836 9.7478H2.24609C1.95477 9.7478 1.71879 9.51174 1.71875 9.22046C1.71875 8.92901 1.95476 8.69312 2.24609 8.69312H4.56836Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.15"
    />
  </svg>
);
